import { Box, CircularProgress, Typography } from '@mui/material'
import './index.scss'

export default function LoadingSpinner({ text = 'Đang tải...' }) {
  return (
    <Box className="TrafficViolationsLoadingSpinner" role="status" aria-live="polite">
      <CircularProgress size={80} thickness={5} />
      <Typography variant="body2" color="textSecondary">
        {text}
      </Typography>
    </Box>
  )
}
